module.exports = __webpack_public_path__ + "34d75b2e9f4400f35616d05093e90998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/invite-team.svg
// module id = 2816
// module chunks = 1